// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var section = "GeneralHighlightsSection-module--section--2hOoV";
export var containerBackground = "GeneralHighlightsSection-module--containerBackground--QG1aO";
export var container = "GeneralHighlightsSection-module--container--29-rt";
export var content = "GeneralHighlightsSection-module--content--3ZEG-";
export var card = "GeneralHighlightsSection-module--card--3CM-M";
export var lastCard = "GeneralHighlightsSection-module--lastCard--3ryCR GeneralHighlightsSection-module--card--3CM-M";
export var cardImage = "GeneralHighlightsSection-module--cardImage--2g0kh";
export var cardText = "GeneralHighlightsSection-module--cardText--2n06D";
export var title = "GeneralHighlightsSection-module--title--2Ngoa";
export var paragraph = "GeneralHighlightsSection-module--paragraph--2axWb";